import React, { ComponentProps } from 'react';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { BlockGuard } from '../../types/api/Block';
import { DefaultView, OptionalEditView, Views } from '../../types/BlockWithViews';
import { useAppContext } from '../../contexts/AppContext/AppContext';
import {
  MembershipsByPageType,
  UserMembershipDefault,
  UserMembershipEdit,
  UserMembershipsContentList,
} from '../../_lib/components/UserMemberships';

type LocationMembershipsDefault = MembershipsByPageType<{ location: UserMembershipDefault[] }>;
type LocationMembershipsEdit = MembershipsByPageType<{ location: UserMembershipEdit[] }>;

export type LocationMembershipsProps = Views<
  DefaultView<LocationMembershipsDefault> & OptionalEditView<LocationMembershipsEdit>
>;

function LocationMemberships({ views }: LocationMembershipsProps) {
  const { editModeInfo } = useAppContext();
  const editModeActive = editModeInfo.active;
  const { memberships } = editModeActive && views.edit ? views.edit.embedded : views.default.embedded;

  const location = memberships?.location;

  return location ? <UserMembershipsContentList memberships={location} /> : null;
}

export const LocationMembershipsBlock = asFetchableBlock(LocationMemberships, BlockType.locationMemberships);
export type LocationMembershipsBlock = ComponentProps<typeof LocationMembershipsBlock>;
export const isLocationMembershipsBlock = BlockGuard<LocationMembershipsBlock>(BlockType.locationMemberships);
